/* eslint-disable max-len */
const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' {...props} viewBox='0 0 95 106' fill='none'>
    <path
      d='M87.3859 39.9437C97.4366 45.7465 97.4366 60.2535 87.3859 66.0563L23.1141 103.164C13.0634 108.966 0.499979 101.713 0.49998 90.1073L0.499983 15.8927C0.499984 4.28712 13.0634 -2.96637 23.1141 2.83642L87.3859 39.9437Z'
      fill='currentColor'
    />
  </svg>
);

export { PlayIcon };
